/*
  RareCut Global Reveal — extends the same quiet fade+rise language used on
  Vault/House of Silver (rc-cinema.js) to the rest of the site: static pages,
  blog, footer, cart, account. Deliberately opt-in per element (classList
  added by this script, never baked into markup as a static opacity:0), and
  guarded by a hard fallback timeout so content can never get stuck invisible
  if this script errors or IntersectionObserver is unavailable — the exact
  risk called out in snippets/product-grid.liquid for the discovery grid.
*/
(function () {
  if (window.__rcGlobalReveal) return;
  window.__rcGlobalReveal = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Individual elements: fade + rise on their own. Whole .rte blocks (not
  // their descendants) so it works regardless of what markup a given page's
  // content is authored with.
  var REVEAL_SELECTOR = [
    '.rte',
    '.blog-post-card',
    '[data-rc-g-reveal]'
  ].join(',');

  // Containers whose direct children should stagger in together.
  var STAGGER_SELECTOR = [
    '.footer-content',
    '[data-rc-g-stagger]'
  ].join(',');

  var EXCLUDE_ANCESTOR = 'header-component,.header-drawer,.cart-drawer,.quick-add-modal,#search-modal,.menu-drawer,[data-rc-reveal],[data-rc-split],.rc-luxe-page,.rc-chapter,.rc-worlds,.rc-manifesto,.rc-proof,.rc-showcase,.rc-strip,.rc-marquee,.rc-portal,.rc-desire,.rc-craft-gallery,.product-grid';

  if (reduced || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('rc-g-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function eligible(el) {
    return !el.closest(EXCLUDE_ANCESTOR);
  }

  function armFallback(el) {
    // Hard fallback: guarantee visibility even if the observer never fires
    // (e.g. element already fully off-screen in a way IO can't reach, or a
    // later script error). Never let content stay invisible past this.
    window.setTimeout(function () { el.classList.add('rc-g-in'); }, 4000);
  }

  function tagOne(el, className) {
    if (el.hasAttribute('data-rc-g-tagged')) return;
    if (!eligible(el)) return;
    el.setAttribute('data-rc-g-tagged', '');
    el.classList.add(className);
    io.observe(el);
    armFallback(el);
  }

  function tag() {
    var reveals = document.querySelectorAll(REVEAL_SELECTOR);
    for (var i = 0; i < reveals.length; i++) tagOne(reveals[i], 'rc-g-reveal');

    var staggers = document.querySelectorAll(STAGGER_SELECTOR);
    for (var j = 0; j < staggers.length; j++) tagOne(staggers[j], 'rc-g-stagger');
  }

  var pending = false;
  function scheduleTag() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      tag();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tag, { once: true });
  } else {
    tag();
  }

  var mo = new MutationObserver(scheduleTag);
  mo.observe(document.body, { childList: true, subtree: true });
})();
